import CourseList from "./components/List"
import CourseListLongRun from "./components/ListLongRun"
import CourseForm from "./components/Form"
import CourseView from "./components/View"
import CourseAttendance from "./components/Attendance"

let module = "courses"

export default [
  { path: "courses", component: CourseList, meta: { module: module, permissions: ["course-access"] } },
  { path: "courses/attendance/:id", component: CourseAttendance, props: true, meta: { module: module, permissions: ["course-access"] } },
  {
    path: "courses/create",
    component: CourseForm,
    props: true,
    meta: { module: module, permissions: ["course-create"] }
  },
  {
    path: "courses/edit/:id",
    component: CourseForm,
    props: true,
    meta: { module: module, permissions: ["course-edit"] }
  },
  {
    path: "courses/view/:id",
    component: CourseView,
    props: true,
    meta: { module: module, permissions: ["course-access"] }
  },

  { path: "courses/longrun", component: CourseListLongRun, meta: { module: module + "-longrun", permissions: ["course-access"] } },
  {
    path: "courses/longrun/create",
    component: CourseForm,
    props: true,
    meta: { module: module + "-longrun", permissions: ["course-create"] }
  },
  {
    path: "courses/longrun/edit/:id",
    component: CourseForm,
    props: true,
    meta: { module: module + "-longrun", permissions: ["course-edit"] }
  },
  {
    path: "courses/longrun/view/:id",
    component: CourseView,
    props: true,
    meta: { module: module + "-longrun", permissions: ["course-access"] }
  },
]
